import TaxCategoryForm from './TaxCategoryForm';

export {
  TaxCategoryForm
}



// WEBPACK FOOTER //
// ./src/components/admin/TaxCategories/index.js